import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=6e79be2d"
import script from "./edit.ts?vue&type=script&lang=js&external"
export * from "./edit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e79be2d')) {
      api.createRecord('6e79be2d', component.options)
    } else {
      api.reload('6e79be2d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=6e79be2d", function () {
      api.rerender('6e79be2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/controleReclamacao/edit.vue"
export default component.exports